import { ConfirmDowngradeModalProps } from "@shared/features/settings/subscription/types";
import Modal from "common/Modal/Modal";
import Text from "common/Typography/Text";
import useTypedTranslation from "@shared/common/i18n/useTypedTranslation";
import { LanguageNameSpaces } from "@shared/types";

const ConfirmDowngradeModal = ({
  isOpen,
  closeModal,
  onOk,
  content,
}: ConfirmDowngradeModalProps) => {
  const { t } = useTypedTranslation(LanguageNameSpaces.BILLING);

  return (
    <Modal
      title={t("confirm_downgrade_modal.title")}
      open={isOpen}
      onCancel={closeModal}
      onOk={onOk}
      width={520}
    >
      {content.map((string, key) => {
        if (string.length) return <Text key={key}>{string}</Text>;
      })}
    </Modal>
  );
};

export default ConfirmDowngradeModal;
